import { gql } from '@apollo/client';

export type MotionDate = {
  startDate: string;
  endDate?: string;
};

export const GET_PROCEEDING_DETAILS = gql`
  query Proceeding($input: String) {
    proceeding(input: $input) {
      chcReceivedDate
      id
      referralDate
      proceedingId
      format
      isJoint
      location
      description
      participantRequestDeadlineDate
      hearingIssuesSetDate
      issuesComment
      reportUpdate
      informationSessionDate
      status
      energyActivityTypes      
      otherComment
      technicalMeetingDates
      siteVisitDates
      motionDates {
        startDate
        endDate
      }
      hearingDates { 
        startDate
        endDate
      }      
    }
  }
`;

export const UPDATE_PROCEEDING_MUTATION = gql`
  mutation UpdateProceeding($input: UpdateProceedingDetails) {
    updateProceeding(input: $input) {
      chcReceivedDate
      id
      proceedingId
      isJoint
      location
      description
      referralDate
      status
      format
      participantRequestDeadlineDate
      hearingIssuesSetDate
      issuesComment
      reportUpdate
      informationSessionDate      
      energyActivityTypes       
      otherComment 
      technicalMeetingDates
      siteVisitDates
      motionDates {
        startDate
        endDate
      }
      hearingDates {
        startDate
        endDate
      }     
    }
  }
`;

export const formatOptions = [
  { value: 'Oral', label: 'Oral' },
  { value: 'Written', label: 'Written' },
  { value: 'Electronic', label: 'Electronic' },
];

export const energyActivityOptions = [
  { value: 'Bitumen Upgrader', label: 'Bitumen Upgrader' },
  { value: 'Brine-Hosted Mineral Facility/Well', label: 'Brine-Hosted Mineral Facility/Well' },
  { value: 'Coal Mine', label: 'Coal Mine' },
  { value: 'Coal Processing Plant', label: 'Coal Processing Plant' },
  { value: 'Enforcement Order', label: 'Enforcement Order' },
  { value: 'Gas Processing Plant', label: 'Gas Processing Plant' },
  { value: 'Geothermal Well', label: 'Geothermal Well' },
  {
    value: 'Liability Related (Transfers, Security, etc.)',
    label: 'Liability Related (Transfers, Security, etc.)',
  },
  { value: 'Oil Sands Mine', label: 'Oil Sands Mine' },
  { value: 'Oil/Gas Facility', label: 'Oil/Gas Facility' },
  { value: 'Oil/Gas Well', label: 'Oil/Gas Well' },
  { value: 'Oilfield Waste Management Facility', label: 'Oilfield Waste Management Facility' },
  { value: 'Pipeline', label: 'Pipeline' },
  { value: 'Primary/Enhanced Recovery in Situ', label: 'Primary/Enhanced Recovery in Situ' },
  { value: 'Reclamation Certificate', label: 'Reclamation Certificate' },
  { value: 'Rock-Hosted Mineral Mine', label: 'Rock-Hosted Mineral Mine' },
  { value: 'Thermal Recovery in Situ', label: 'Thermal Recovery in Situ' },
  { value: 'Other', label: 'Other' },
];
